import React, { FC, memo } from 'react'

import { Button } from '@Components/Button'
import {
  useDefaultCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Default/hooks/useDefaultCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { useTranslation } from '@Globals/Translations'
import { CheckoutV2FinalizeCartResult } from '@Pages/onestepcheckout'

import styles from './PostFinance.module.scss'

export const PostFinanceButton: FC<CheckoutPaymentComponentProps> = memo(({ option, submitPayment }) => {
  const { t } = useTranslation()
  const { handlePaymentSubmitResponse } = useDefaultCheckoutResponse()

  return (
    <div className={styles.postFinanceWrapper}>
      <Button
        onClick={() => {
          submitPayment(
            { type: option.type },
            (response: CheckoutV2FinalizeCartResult) => handlePaymentSubmitResponse(option.type, response),
          )
        }}
      >
        {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
      </Button>
    </div>
  )
})
